/**
 * Проверяет, что ошибка является GraphQLError.
 *
 * @param error - Значение неизвестного типа.
 * @returns true, если error является GraphQLError.
 */
export const isGraphQLError = (error) => {
    return !!error && typeof error === 'object' && 'message' in error && typeof error.message === 'string';
};
/**
 * Проверяет, что ошибка является массивом GraphQLError.
 *
 *
 * @param error - Значение неизвестного типа.
 * @returns true, если непустой массив GraphQLError.
 */
export const isGraphQLErrorArray = (error) => {
    return Array.isArray(error) && error.length > 0 && isGraphQLError(error[0]);
};
